import React from "react";
import { Link } from "react-router-dom";
import api from "../../service/api";
import { useState, useEffect } from "react";
import { Paper, TablePagination, Typography, Tooltip, IconButton } from "@mui/material";
import ProgressBar from "../progress/progressBar";
import CONSTANT from "../../Constant/Constant";
import moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useHistory } from "react-router-dom";
import "./admin-track-request.css";
import FilterOptions from "./filter-options";
import PopUpMsg from "../merge-profile/popUpMsg";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AdminTrackExportConfigData from "../../config/AdminTrackExportConfig.json";
import ExportAdminTrackCSV from "../admin-track-request/AdminTrackExportFile";
import { Alert, AlertTitle } from '@mui/material';
import ErrorPageAdmin from '../error/error';
import jsondata from "../../config/AdminTrackPageConfig.json";
import { ContentCopy, Done } from "@mui/icons-material";
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
 

const AdminTrackRequest = (props) => {
  const [activeTab, setActiveTab] = useState("DCR");
  const history = useHistory();
  const [data] = React.useState(props.data);
  const [progressFlag, setProgressFlag] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [progressBar, setProgressBar] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState({
    heading: "",
    message: "",
  });
  const [loadingButton, setLoadingButton] = useState(false);
  const [dcrToken, setDcrToken] = useState("");
  const [mergeToken, setMergeToken] = useState("");
  const [subscribeToken, setSubcribeToken] = useState("");
  const [activeTabData, setActiveTabData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [previousData, setpreviousData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [filterFlag, setFilterFlag] = useState(false);
  const [currentPage, setCurrentPage] = useState({});
  const [noAccess, setNoAccess] = useState(false);
  const [isCopied, setIsCopied] = useState(null);
  let paginationIndexStart = "";
  let paginationIndexEnd = "";
  let paginationDataSliced = [];

  /**
   * funtion for no data in filter form
   */
  const onOK = () => {
    setShowPopup(false);
  };

  /**
   * request type tabs handling function
   */
  const handleRequest = (type) => {
        setActiveTab(type);
    setCurrentPage({...currentPage, [activeTab]: page})
    setPage(currentPage[type] ? currentPage[type] : 0 );
  };
  



  /**
   * handling error
   */
  const handleError = (error) => {
    setErrorFlag(true);
    let errorDetail = error;
    let msg = errorDetail.response
      ? errorDetail.response.data.errorCode
      : "Internal Server Error!";
    setErrorMsg(msg ? msg : "Internal Server Error!");
    setProgressFlag(false);
  };

  /**
   * funtion for assigning classes according to status of request
   */

  // const getStatusClassdcr = (state) => {
  //   switch (state) {
  //     case CONSTANT.STATE[0]:
  //       return "text-white rounded py-2 px-3 bg-primary";
  //     case CONSTANT.STATE[1]:
  //       return "text-white rounded py-2 px-3 bg-success";
  //     case CONSTANT.STATE[2]:
  //       return "text-white rounded py-2 px-3 bg-danger";
  //     case CONSTANT.STATE[3]:
  //       return "text-white rounded py-2 px-3 bg-warning";
  //     case CONSTANT.STATE[4]:
  //       return "text-white rounded py-2 px-3 bg-primary";
  //     case CONSTANT.STATE[5]:
  //       return "text-white rounded py-2 px-3 bg-success";
  //     case CONSTANT.STATE[6]:
  //       return "text-white rounded py-2 px-3 bg-danger";
  //     case CONSTANT.STATE[7]:
  //       return "text-white rounded py-2 px-3 bg-success";
  //     case "AWAITING_REVIEW":
  //       return "text-white rounded py-2 px-3 bg-primary";
  //     case CONSTANT.STATE[9]:
  //       return "text-white rounded py-2 px-3 bg-success";
  //     default:
  //       return "text-white rounded py-2 px-3 bg-primary";
  //   }
  // };

  /**
   * handle chnage in table page
   */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  /**
   * handle chnage in rows per page in table
   */
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage({})
    setPage(0);
  };


  /**
   * handle Copy to clipboard functionality
   */
   const handleCopyClipboard = (event, data) => {
    event.stopPropagation();
    navigator.clipboard.writeText(data);
    setIsCopied(data);
    setTimeout(() => setIsCopied(null), 1000);
  };

  /**
   * function for handling the all request and sorting as per type after fetching
   */
  const dataOperation = (data) => {
    
    setActiveTabData(
      data.reduce((group, arr) => {
        const { RequestType } = arr;
        group[RequestType] = group[RequestType] ?? [];
        group[RequestType].push(arr);
        return group;
      }, {})
    );
  };

  paginationIndexStart = page * rowsPerPage;
  paginationIndexEnd = page * rowsPerPage + rowsPerPage;
  paginationDataSliced = activeTabData[activeTab]?.slice(
    paginationIndexStart,
    paginationIndexEnd
  );

  /**
   * fetching data about admin access
   */
  useEffect(() => {
    setProgressFlag(true);
    fetchData()     
  }, []);

  /**
   * useEffect for state update
   */
  useEffect(() => {
    dataOperation(
      previousData.sort((a, b) => {
        if (
          moment
            .utc(new Date(a.createdTime || a.CreatedDate))
            .isAfter(moment.utc(new Date(b.createdTime || b.CreatedDate)))
        ) {
          return -1;
        } else {
          return 1;
        }
      })
    );
  }, [previousData]);

  /**
   * fetching all records using api
   */
  async function fetchData(data) {
    if (data !== undefined && Object.keys(data).length > 0) {      
      setProgressBar(true);
      setFilterFlag(true);
      setSearchData(data);
      setpreviousData([]);
      setMergeToken("");
      setDcrToken("");
      setErrorFlag(false);
      await api
        .getAllRequest(true, null, data)
        .then((response) => {
          if (response.data.response.length > 0) {
            let allData = response.data.response;
            let tokenData = response.data.token;
            setpreviousData(allData);
            setDcrToken(tokenData.dcrNextToken);
            setMergeToken(tokenData.mergeNextToken);
            setSubcribeToken(tokenData.subscriptionNextToken);
            setActiveTab("DCR");            
            setPage(0);
            setNoData(false);
            setProgressBar(false);
          } else {
            setNoData(true);
            setProgressBar(false);
            setProgressFlag(false);
          }
        })
        .catch((error) => {
          let responseError = error
          handleError(responseError);
          setProgressBar(false);
          setProgressFlag(false);
          setNoData(false);
          if(responseError.response?.status === 400){
            setNoAccess(true)
          }
        });
    } else{
      setpreviousData([]);
      setProgressBar(true);
      setFilterFlag(false);
      setMergeToken("");
      setDcrToken("");
      setErrorFlag(false);
      await api
        .getAllRequest(true, null, null)
        .then((response) => {
          if (response.data.response.length > 0) {
            let allData = response.data.response;
            let tokenData = response.data.token;
            setpreviousData(allData);
            setDcrToken(tokenData.dcrNextToken);
            setMergeToken(tokenData.mergeNextToken);
            setSubcribeToken(tokenData.subscriptionNextToken);
            setActiveTab("DCR");            
            setProgressBar(false);
            setProgressFlag(false);
            setNoData(false);            
          } else {
            setNoData(true);
            setProgressBar(false);
            setProgressFlag(false);
          }
        })
        .catch((error) => {
          let responseError = error
          handleError(responseError);
          setNoData(true);
          setProgressBar(false);
          setProgressFlag(false);
          if(responseError.response?.status === 400){
            setNoAccess(true)
          }        
        });
    }
  }
  /**
     * go Back to last page
     */
  const goBack = () => {
    props.history.goBack()
  };

  /* 
  load more button function
  */

  const loadMoredata = () => {
    setLoadingButton(true);
    loadMore();
  };
  

  /**
   * funtion for laod more data using api
   */
  async function loadMore() {
    setErrorFlag(false);
    await (filterFlag
      ? api.getAllRequest(
          true,
          activeTab,
          searchData,
          activeTab === "DCR"
            ? dcrToken
            : activeTab === "Merge"
            ? mergeToken
            : subscribeToken
        )
      : api.getAllRequest(
          true,
          activeTab,
          null,
          activeTab === "DCR"
            ? dcrToken
            : activeTab === "Merge"
            ? mergeToken
            : subscribeToken
        )
    )
      .then((response) => {
        let tokenData = response.data.token;
        if (activeTab === "DCR") {
          setDcrToken(tokenData.dcrNextToken);
        } else if (activeTab === "Merge") {
          setMergeToken(tokenData.mergeNextToken);
        } else {
          setSubcribeToken(tokenData.subscriptionNextToken);
        }

        if (response.data.response.length > 0) {
          let allData = response.data.response;
          setpreviousData([...previousData, ...allData]);
          setProgressBar(false);
          setPage(page + 1);
          setNoData(false);
          setLoadingButton(false);
        } else {
          setProgressBar(false);
          setLoadingButton(false);
        }
      })
      .catch((error) => {
        handleError(error);
        setLoadingButton(false);
      });
  }

  /**
   * funtion for setting up data for popup
   */
  const openPopup = () => {
    setShowPopup(true);
    setPopUpMessage({
      heading: "Warning",
      message: "Please set at least one search filter.",
      onOk: "Confirm",
    });
  };

  return (
    <div className="container body-height extra-margin-top-less">
      {!progressFlag && !noAccess &&  (
        <FilterOptions
          className="mb-5"
          searchItem={(data) => fetchData(data)}
          openPopup={() => openPopup()}
        />
      )}

      {(progressFlag || progressBar) && (
        <div
          className={
            progressFlag
              ? "d-flex justify-content-center extra-margin-top"
              : "d-flex justify-content-center mt-5"
          }
        >
          <ProgressBar />
        </div>
      )}

      {!progressFlag && !progressBar && !noAccess && (
        <>
          <Paper square className="mb-2 mt-5">
            <div className="row">
              <div className="col-md-8">
                <ul className="nav">
                  <li
                    id="dcr"
                    className={activeTab === "DCR" ? "active" : ""}
                    onClick={() => handleRequest("DCR")}
                  >
                    DCR
                  </li>
                  <li
                    id="merge"
                    className={activeTab === "Merge" ? "active" : ""}
                    onClick={() => handleRequest("Merge")}
                  >
                    Merge
                  </li>
                  <li
                    id="subscription"
                    className={activeTab === "Subscription" ? "active" : ""}
                    onClick={() => handleRequest("Subscription")}
                  >
                    Subscription
                  </li>
                </ul>
              </div>
              <div className="col-md-4" style={{ padding: "6px 20px 0px 0px" }}>
                <ExportAdminTrackCSV
                  csvData={previousData}
                  fileName={
                    AdminTrackExportConfigData.fileName +
                    "-" +
                    moment().utc().format("MMDDYYYYHHmmss")
                  }
                />
              </div>
            </div>
          </Paper>

          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead id="track-head">
                {
                  <TableRow>
                    <TableCell className="font" align="center">
                      <Typography
                        variant="subtitle1"
                        className="fw-bold"
                        value={data}
                        sx={{ minWidth: "150px" }}
                      >
                        Request Id
                      </Typography>
                    </TableCell>

                    <TableCell className="font" align="center">
                      <Typography
                        variant="subtitle1"
                        className="fw-bold"
                        sx={{ minWidth: "150px" }}
                      >
                        Country
                      </Typography>
                    </TableCell>

                    <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "150px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        Managed By
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "250px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        Status
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "200px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        Created Time{" "}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "200px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        {" "}
                        Updated Time
                      </Typography>
                    </TableCell>

                    <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "200px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        {" "}
                        Created By
                      </Typography>
                    </TableCell>

                    <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "200px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        {" "}
                        Requester Email
                      </Typography>
                    </TableCell>

                    {/* <TableCell
                      align="center"
                      className="font"
                      sx={{ minWidth: "150px" }}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        View Detail
                      </Typography>
                    </TableCell> */}
                  </TableRow>
                }
              </TableHead>

              <TableBody>
                {activeTabData[activeTab]?.length === undefined || noData ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Request Found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginationDataSliced.map((row) => {
                    return (
                      <TableRow key={row.Id}>
                       {row.RequestType === "Merge" && (
                          <TableCell align="left" id="track-head">
                            <span style={{display: "flex", alignItems:"center", textAlign:"center"}}>
                            <span >{row.Id}</span>
                            <Tooltip title={isCopied && isCopied === row.Id ? "Copied!" : "Click to Copy"}>
                              <IconButton size="small" aria-label="copy" color="primary" onClick={(e) => handleCopyClipboard(e, row.Id)}>
                                {isCopied && isCopied === row.Id ? <Done fontSize="10px" /> : <ContentCopy fontSize={'10px'} />}
                              </IconButton>
                            </Tooltip>
                              <Tooltip disableFocusListener title={"View Details"}>
                                <IconButton size="small" aria-label="link " color="primary" component={Link} to={`/track-mergeDetail/${row.Id}`}>
                                  <OpenInBrowserIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              </span>
                          </TableCell>
                        )}
                        
                        {row.RequestType === "DCR" && row.endsource === "VENDOR" && row.managed_by !== "OPEN-DATA"&& (
                          <TableCell align="left" id="track-head">
                            <span style={{display: "flex", alignItems:"center", textAlign:"center"}}>
                            <span >{row.Id}</span>
                            <Tooltip title={isCopied && isCopied === row.Id ? "Copied!" : "Click to Copy"}>
                              <IconButton size="small" aria-label="copy" color="primary" onClick={(e) => handleCopyClipboard(e, row.Id)}>
                                {isCopied && isCopied === row.Id ? <Done fontSize="10px" /> : <ContentCopy fontSize={'10px'} />}
                              </IconButton>
                            </Tooltip>
                              <Tooltip disableFocusListener title={"View Details"}>
                                <IconButton size="small" aria-label="link " color="primary" component={Link} to={row.managed_by === 'VNETWORK' ? `/track-vnDetail/${row.Id}` : `/track-iqviaDetail/${row.Id}`}>
                                  <OpenInBrowserIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              </span>
                          </TableCell>
                        )}

                        
                        {row.RequestType === "DCR" && (row.endsource !== "VENDOR" || row.managed_by === 'OPEN-DATA') && (
                          <TableCell align="left" id="track-head">
                            <span style={{display: "flex", alignItems:"center", textAlign:"center"}}>
                            <span >{row.Id}</span>
                            <Tooltip title={isCopied && isCopied === row.Id ? "Copied!" : "Click to Copy"}>
                              <IconButton size="small" aria-label="copy" color="primary" onClick={(e) => handleCopyClipboard(e, row.Id)}>
                                {isCopied && isCopied === row.Id ? <Done fontSize="10px" /> : <ContentCopy fontSize={'10px'} />}
                              </IconButton>
                            </Tooltip>
                              <Tooltip disableFocusListener title={"View Details"}>
                                <IconButton size="small" aria-label="link " color="primary" component={Link} to={`/view-all/requests/${row.Id}/${row.managed_by}`}>
                                  <OpenInBrowserIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              </span>
                          </TableCell>
                          
                        )}
                        {row.RequestType === "Subscription" && (
                          <TableCell align="left" id="track-head">
                            <span style={{display: "flex", alignItems:"center", textAlign:"center"}}>
                            <span >{row.Id}</span>
                            <Tooltip title={isCopied && isCopied === row.Id ? "Copied!" : "Click to Copy"}>
                              <IconButton size="small" aria-label="copy" color="primary" onClick={(e) => handleCopyClipboard(e, row.Id)}>
                                {isCopied && isCopied === row.Id ? <Done fontSize="10px" /> : <ContentCopy fontSize={'10px'} />}
                              </IconButton>
                            </Tooltip>
                              <Tooltip disableFocusListener title={"View Details"}>
                                <IconButton size="small" aria-label="link " color="primary" component={Link} to={`/track-subscribedDetail/${row.Id}`}>
                                  <OpenInBrowserIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              </span>
                          </TableCell>
                        )}

                        <TableCell align="center" component="th" scope="row">
                          {row.Country}
                        </TableCell>

                        <TableCell align="center">{jsondata[row.managed_by].label}</TableCell>
                        <TableCell align="center">
                          {CONSTANT.DCR_STATES.includes(row.state) ? (
                            (() => {
                              // Safely resolve managed and default status entries
                              const managed = jsondata && jsondata[row.managed_by] ? jsondata[row.managed_by] : null;
                              const defaultStatusMap = (jsondata && jsondata['default'] && jsondata['default']['status']) ? jsondata['default']['status'] : {};
                              const managedStatusMap = managed && managed['status'] ? managed['status'] : {};
                              const statusEntry = (managedStatusMap && managedStatusMap[row.state]) || defaultStatusMap[row.state] || defaultStatusMap['default'] || {};
                              const btnClass = statusEntry && statusEntry['btnDesign'] ? statusEntry['btnDesign'] : 'text-white rounded py-2 px-3  bg-primary';
                              const label = row.state === 'AWAITING_REVIEW' ? 'Awaiting Review' : (statusEntry && statusEntry['label'] ? statusEntry['label'] : row.state);
                              return <span className={btnClass}>{label} </span>;
                            })()
                          ) : (
                            <span className="text-white rounded py-2 px-3  bg-primary">{row.state}</span>
                          )}
                        </TableCell>
                        <TableCell align="center">{row.CreatedDate}</TableCell>

                        <TableCell align="center">{row.UpdatedDate}</TableCell>
                        <TableCell align="center">{row?.RequestorName && row?.CreatedBy ? `${row.RequestorName.includes(" - Network") ? row.RequestorName.split(" - Network")[0].trim() : row.RequestorName} (${row.CreatedBy})` : row?.CreatedBy || row?.RequestorName ||'N/A'}</TableCell>
                        <TableCell align="center">{row?.RequestorEmail ? row.RequestorEmail : 'N/A'}</TableCell>
                        {/* {row.RequestType === "Merge" && (
                          <TableCell align="center" id="track-head">
                            <Button
                              className="linkButton"
                              // onClick={() =>
                              //   history.push({
                              //     pathname: `/track-mergeDetail/${row.Id}`                                                                   
                              //   })
                              // }
                              component={Link} to={`/track-mergeDetail/${row.Id}`}
                            >
                              
                              {row.Id}
                            </Button>
                          </TableCell>
                        )}
                        
                        {row.RequestType === "DCR" && row.endsource === "VENDOR" && (
                          <TableCell align="center" id="track-head">
                            <Button
                              className="linkButton"
                              // onClick={() =>
                              //   history.push({
                              //     pathname: `/track-iqviaDetail/${row.Id}`,                                                                   
                              //   })
                              // }
                              component={Link} to={row.managed_by === 'VNETWORK' ? `/track-vnDetail/${row.Id}` : `/track-iqviaDetail/${row.Id}`}
                            >
                              {" "}
                              {row.Id}
                            </Button>
                          </TableCell>
                        )}

                        {row.RequestType === "DCR" && row.endsource !== "VENDOR" && (
                          <TableCell align="center" id="track-head">
                            <Button
                              className="linkButton"
                              // onClick={() =>
                              //   history.push({
                              //     pathname: `/view-all/requests/${row.Id}/${row.managed_by}`,                                                                    
                              //   })
                              // }
                              component={Link} to={`/view-all/requests/${row.Id}/${row.managed_by}`}
                            >
                              {" "}
                              {row.Id}
                            </Button>
                          </TableCell>
                        )}
                        {row.RequestType === "Subscription" && (
                          <TableCell align="center" id="track-head">
                            <Button
                              className="linkButton"
                              // onClick={() =>
                              //   history.push({
                              //     pathname: `/track-subscribedDetail/${row.Id}`,                                                                  
                              //   })
                              // }
                              component={Link} to={`/track-subscribedDetail/${row.Id}`}
                            >
                              {row.Id}
                            </Button>
                          </TableCell>
                        )} */}
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 20, 25, 50]}
            component="div"
            count={
              noData || activeTabData[activeTab]?.length === undefined
                ? 0
                : activeTabData[activeTab]?.length
            }
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            id="track-head"
            backIconButtonProps={{
              disabled: page === 0,
            }}
            nextIconButtonProps={{
              disabled:
                page ===
                Math.ceil(activeTabData[activeTab]?.length / rowsPerPage) - 1,
            }}
          />

          {page ===
            Math.ceil(activeTabData[activeTab]?.length / rowsPerPage) - 1 &&
            !noData &&
            (activeTab === "DCR"
              ? dcrToken
              : activeTab === "Merge"
              ? mergeToken
              : subscribeToken) && (
              <div className="mb-5">
                <LoadingButton
                  className="btn btn-secondry border request"
                  style={{ textAlign: "right", float: "right", border: "none" }}
                  loading={loadingButton}
                  loadingPosition="end"
                  endIcon={
                    <ArrowForwardIosIcon style={{ fontSize: "medium" }} />
                  }
                  variant="outlined"
                  onClick={() => loadMoredata()}
                >
                  Load More
                </LoadingButton>
              </div>
            )}
        </>
      )}
       {
          errorFlag && !progressFlag && !progressBar && !noAccess &&
            <div className="d-flex justify-content-center extra-margin-top">
              <Alert severity="error" className='container'>
                  <AlertTitle id='alert-text'>{errorMsg}</AlertTitle>
                    <strong className='link pointer text-primary' id='alert-text' onClick={goBack}>back!</strong>
                  </Alert>
            </div>
        }

        {
          !progressFlag && !progressBar && noAccess &&
            <ErrorPageAdmin />
        } 

        
     

      {showPopup && (
        <PopUpMsg popUpMessage={popUpMessage} onOK={() => onOK()} />
      )}
    </div>
  );
};
export default AdminTrackRequest;